module.exports = __webpack_public_path__ + "static/img/internship_report.fd17e82b.png";